module.exports = __webpack_public_path__ + "img/117.4cd43403.png";